<div class="create-client-modal" data-testid="modal-add-client">
  <div class="create-client-modal__header">
    <h2 class="create-client-modal__title">{{ modalTitle }}</h2>
    <button class="create-client-modal__close-button" type="button" (click)="onCancel()" aria-label="Close modal">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="create-client-modal__content">
    <form [formGroup]="clientForm" class="create-client-modal__form">
      <div class="create-client-modal__form-section">
        <mat-form-field appearance="outline" class="create-client-modal__field">
          <mat-label>Client Name *</mat-label>
          <input
            matInput
            formControlName="name"
            placeholder="Enter client's full name"
            autocomplete="name"
            data-testid="input-client-name"
            />
          <mat-error>{{ getNameErrorMessage() }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="create-client-modal__field create-client-modal__field--textarea">
          <mat-label>Notes</mat-label>
          <textarea matInput formControlName="notes" placeholder="Add any notes about this client (optional)" rows="3"></textarea>
        </mat-form-field>

        <!-- Wheel Selection Section - Only show if client is saved or in edit mode -->
        @if (clientSaved()) {
          <div class="create-client-modal__wheel-section">
            <h3 class="create-client-modal__section-title">Generate Client Link</h3>

            <mat-form-field appearance="outline" class="create-client-modal__field">
              <mat-label>Select Wheel</mat-label>
              <mat-select formControlName="selectedWheel" [disabled]="(hasWheelsAvailable$ | async) === false" data-testid="select-wheel">
                @for (wheel of (wheels$ | async); track wheel) {
                  <mat-option [value]="wheel.id">
                    {{ wheel.name }}
                  </mat-option>
                }
              </mat-select>
              @if ((hasWheelsAvailable$ | async) === false) {
                <mat-hint>No wheels available. Create a wheel first.</mat-hint>
              }
            </mat-form-field>

            <button
              mat-raised-button
              color="primary"
              type="button"
              [disabled]="!isWheelSelected || generatingLink()"
              (click)="onGenerateLink()"
              class="create-client-modal__generate-button"
              data-testid="btn-generate-link"
              >
              @if (generatingLink()) { Generating... } @else { Create a link }
              </button>
            </div>
          } @else if (mode === 'create') {
            <!-- Informational message for new clients -->
            <div class="create-client-modal__info-section">
              <mat-icon class="create-client-modal__info-icon">info</mat-icon>
              <p class="create-client-modal__info-text">Save the client first to create wheel link for the user.</p>
            </div>
          }

          <!-- Generated Links Table -->
          @if (generatedLinks().length > 0) {
            <div class="create-client-modal__links-section">
              <h4 class="create-client-modal__section-subtitle">Links</h4>
              <div class="create-client-modal__links-table">
                @for (link of generatedLinks(); track link.id) {
                  <div class="create-client-modal__link-row">
                    <div class="create-client-modal__link-info">
                      <span class="create-client-modal__wheel-name">{{ link.wheelName }}</span>
                      <span class="create-client-modal__link-url">{{ link.route }}</span>
                    </div>
                    <div class="create-client-modal__link-actions">
                      <button
                        mat-icon-button
                        [cdkCopyToClipboard]="link.linkUrl"
                        (click)="onCopyLink()"
                        matTooltip="Copy link"
                        class="create-client-modal__copy-button"
                        >
                        <mat-icon>content_copy</mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        color="warn"
                        (click)="onDeleteLink(link)"
                        matTooltip="Delete link"
                        class="create-client-modal__delete-button"
                        >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </form>
    </div>

    <div class="create-client-modal__footer">
      <button class="create-client-modal__button create-client-modal__button--secondary" type="button" (click)="onCancel()">Cancel</button>

      @if (this.isModified()) {
        <button
          [disabled]="!clientForm.valid || isSavingClient()"
          (click)="onSaveClient()"
          class="create-client-modal__button create-client-modal__button--primary"
          type="button"
          >
          @if (isSavingClient()) { Saving... } @else { Save }
          </button>
        }

        @if (!this.isModified()) {
          <button
            (click)="onCancel()"
            class="create-client-modal__button create-client-modal__button--primary"
            type="button"
            >
            Close
          </button>
        }
      </div>
    </div>
